import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import reportActions from "../../redux/reports/actions";
import genericActions from "../../redux/generic/actions";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
import ActivationBatchDetails from "../../components/batchDetails/ActivationBatchDetails";
const { getACode } = genericActions;
const { getactivationBatchReports, resetMessage } = reportActions;

const BatchActivationReport = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { aCodeList } = useSelector(state => state.generic);
    const [searchItem, setSearchItem] = useState("");
    const today = new Date();
    const beforeTwoDays = new Date();
    beforeTwoDays.setDate(beforeTwoDays.getDate() - 2);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const { activationBatchReports, activationBatchReportsLoading, } = useSelector((state) => state.reports)
    const { defaultCurrency } = useSelector((state) => state.auth);
    const [selectedBatchId, setSelectedBatchId] = useState('');
    const [showBatchDetail, setShowBatchDetail] = useState(false);


    const { register, handleSubmit, reset, getValues, formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: {
            distributorID: "",
            batchID: "",
            fromDate: formatDate(beforeTwoDays),
            toDate: formatDate(today),
            isBatchDetail: false,
        },
    });

    useEffect(() => {
        dispatch(getACode());
        loadBatchReport({
            distributorID: "",
            batchID: "",
            fromDate: formatDate(beforeTwoDays),
            toDate: formatDate(today),
        });
    }, [dispatch]);


    const columns = [
        { displayName: "Batch Id", key: "batchId" },
        { displayName: "Activation Date", key: "ActivationDate" },
        { displayName: "Total SIM Count", key: "TotalSimCount" },
        { displayName: "SuccessCount", key: "SuccessCount" },
        { displayName: "Pending Count", key: "PendingCount" },
        { displayName: "Timeout Count", key: "TimeoutCount" },
        { displayName: "Failed Count", key: "FailedCount" },
        { displayName: "Status", key: "BatchStatus" },
        { displayName: "Action", key: "action" },

    ];

    const filteredItems = useMemo(() => {
        return Array.isArray(activationBatchReports) && activationBatchReports.length > 0
            ? activationBatchReports.filter(item => {
                if (!searchItem) return true;
                return Object.values(item).some(val => typeof val === "string" && val.toLowerCase().includes(searchItem.toLowerCase()));
            })
            : [];
    }, [activationBatchReports, searchItem]);

    const rowData = useMemo(() => {
        return (filteredItems || []).map((item) => ({
            batchId: item["BATCHID"],
            ActivationDate: item["ACTIVATIONDATE"],
            TotalSimCount: item["TotalSimCount"],
            SuccessCount: item["SuccessCount"],
            PendingCount: item["PendingCount"],
            TimeoutCount: item["TimeoutCount"],
            FailedCount: item["FailedCount"],
            BatchStatus: item["BATCHSTATUS"],
            action: (
                <button
                    className="btn btn-sm btn-primary-light btn-rounded"
                    onClick={() => handleViewDetails(item)}
                >
                    <i className="ri-eye-line"></i>
                </button>
            )
        }));
    }, [filteredItems]);

    const onSubmit = (data) => {
        loadBatchReport(data);
    };

    const handleViewDetails = (reqData) => {
        setSelectedBatchId(reqData?.BATCHID);
        setShowBatchDetail(true);
    }

    const loadBatchReport = (formData) => {
        dispatch(getactivationBatchReports({
            distributorID: Number(formData.distributorID || 0),
            batchID: formData.batchID || "",
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isBatchDetail: false,
        }))
    }

    const handleReset = () => {
        const defaultData = {
            distributorID: "",
            batchID: "",
            fromDate: formatDate(beforeTwoDays),
            toDate: formatDate(today),
        };

        reset(defaultData);
        setSearchItem("");
        loadBatchReport(defaultData);
    };

    const handleExportExcel = () => {
        const data = filteredItems.map(item => ({
            "Batch ID": item["BATCHID"],
            "Activation Date": item["ACTIVATIONDATE"],
            "Total SIM Count": item["TotalSimCount"],
            "Success Count": item["SuccessCount"],
            "Pending Count": item["PendingCount"],
            "Timeout Count": item["TimeoutCount"],
            "Failed Count": item["FailedCount"],
            "Remark": item["isBatchDetail"],
            "BATCH STATUS": item["BATCHSTATUS"],
        }));

        downloadExcelSampleFile(data, "activation-batch-report.xlsx");
    };


    return (
        <>
            {!showBatchDetail ? <CardLayout
                title="Activation Batch Report"
                icon="ri-file-chart-line "
                rightContent={
                    <Button
                        title="Excel"
                        buttonType="button"
                        variant="secondary"
                        onClick={handleExportExcel}
                        icon={<i className="ri-download-cloud-line me-2" />}
                    />}
            >
                <div>
                    {/* Body */}
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div
                            className="row"

                        >
                            {/* ACode */}
                            <div className="col-lg-2 col-md-4">
                                <label className="form-label fw-semibold">ACode</label>
                                <select
                                    className="form-select"
                                    {...register("distributorID")}
                                >
                                    <option value="">Select ACode</option>

                                    {aCodeList?.map((item) => (
                                        <option
                                            key={item.Id}
                                            value={item.Id} >
                                            {item.ACode}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Batch ID */}
                            <div className="col-lg-3 col-md-4">
                                <label className="form-label fw-semibold">Batch ID</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Batch ID"
                                    {...register("batchID")}
                                />
                            </div>

                            {/* From Date */}
                            <div className="col-lg-2 col-md-4">
                                <label className="form-label fw-semibold">From Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    {...register("fromDate")}
                                />
                            </div>

                            {/* To Date */}
                            <div className="col-lg-2 col-md-4">
                                <label className="form-label fw-semibold">To Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    {...register("toDate")}
                                />
                            </div>

                            <div className="col-lg-3 col-md-6 d-flex align-items-end gap-3" style={{ height: '70px' }}>
                                {/* Buttons */}
                                <Button
                                    title="Get Report"
                                    buttonType="submit"
                                    variant="primary"
                                    disable={activationBatchReportsLoading}
                                    loading={activationBatchReportsLoading}
                                    icon={<i className="ri-search-line me-2"></i>}
                                    style={activationBatchReportsLoading ? { width: '46.5%', padding: '10px 2px' } : {}}
                                />

                                <Button
                                    title="Reset"
                                    buttonType="button"
                                    variant="secondary"
                                    onClick={handleReset}
                                    icon={<i className="ri-refresh-line me-2"></i>}
                                />
                            </div>
                            <div className="col-lg-3 offset-lg-9 col-md-4 d-flex align-items-end" style={{ height: '70px' }}>
                                <input
                                    type="search"
                                    onChange={(e) => setSearchItem(e.target.value)}
                                    className="form-control form-control-sm"
                                    placeholder="Search..."
                                />
                            </div>
                        </div>
                    </form>
                    {/* Search Form end */}
                </div>
                {/* Table */}
                <div className="mt-2">
                    <Table
                        columns={columns}
                        data={rowData}
                        pagination
                        loading={activationBatchReportsLoading}
                        tableHeight="270px"
                    />

                </div>
            </CardLayout> :
                <ActivationBatchDetails
                    selectedBatchId={selectedBatchId}
                    onBack={() => {
                        setShowBatchDetail(false);
                        setSelectedBatchId("");
                        loadBatchReport(getValues());
                    }} />}
        </>
    );
};

export default BatchActivationReport;

